export default "__VITE_ASSET__ntnxNSnl__"